export default {
  total: function total(state) {
    return state.total;
  },
  items: function items(state) {
    return state.items;
  },
  success: function success(state) {
    return state.success;
  },
  successServer: function successServer(state) {
    return state.successServer;
  },
  state: function state(_state) {
    return _state.cartState;
  }
};